import React, { useContext, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Tldraw,
  DefaultQuickActions,
  DefaultQuickActionsContent,
  TLComponents,
  TldrawUiMenuItem,
} from "tldraw";
import { CredsContext } from "./Contexts";
import CustomAlert from "./CustomAlert";
import Tools from "./JNSTools";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import Dialog_AddWorkspace from "./Dialog_AddWorkspace";
import "tldraw/tldraw.css";

//import html2canvas from "html2canvas";

function TLDrawComponent(props) {
  const creds = useContext(CredsContext).creds;
  const editor = useRef();
  const [whiteboardName, setWhiteboardName] = useState(
    "Untitled " /* + new Date().toLocaleString()*/,
  );
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openWsConfirmation, setOpenWsConfirmation] = useState(false);
  const [openSaving, setOpenSaving] = useState(false);
  const [snapshotArray, setSnapshotArray] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const workspaceid = useRef();
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const handleMount = (ed) => {
    editor.current = ed;
  };

  useEffect(() => {
    const requestString =
      authString +
      '<Read type="Workspacelink" method="equal to" limit="1"><Workspacelink><recordid>' +
      props.projectObject.id +
      "</recordid></Workspacelink></Read></request>";

    Tools.fetchPost(requestString, urlString, "Workspacelink").then(
      (rawWsLink) => {
        if (rawWsLink.xml.length > 0) {
          const wsLinkArray = Tools.xmlToArray(rawWsLink.xml);
          workspaceid.current = wsLinkArray[0].workspaceid;
        }
      },
    );

    populateSnapshots();
  }, []);

  const handleNameChange = (event) => {
    setWhiteboardName(event.target.value);
  };

  const handleConfirmationClose = () => {
    setOpenConfirmation(false);
  };

  const handleSavingClose = () => {
    setOpenSaving(false);
  };

  const handleDelete = (event) => {
    const tempSnapshotArray = JSON.parse(JSON.stringify(snapshotArray));
    //const id = JSON.stringify(tempSnapshotArray[0].id);
    /*const delName = event.target.dataset.linkinfo;
    console.log("delName: " + delName);
    const readString =
      authString +
      '<Read type="Preference" method="equal to" limit="100"><Preference><group_name>tldrawSnapshots_proj' +
      props.projectObject.id +
      "</group_name><name>" +
      delName +
      "</name></Preference></Read></request>";
    Tools.fetchPost(readString, urlString, "Preference").then((rawRecord) => {
      if (rawRecord.xml.length > 0) {
        const prefRecord = Tools.xmlToArray(rawRecord.xml);

        const linkId = prefRecord[0].id;
*/
    const linkId = event.target.id.substring(event.target.id.indexOf("_") + 1);
    const deleteString =
      authString +
      '<Modify type="Preference"><Preference><id>' +
      linkId +
      "</id><group_name>whiteboardDeleteTest</group_name></Preference></Modify></request>";
    Tools.fetchPost(deleteString, urlString);

    const delIndex = tempSnapshotArray.findIndex(
      (elem) => parseInt(elem.id) == parseInt(linkId),
    );
    tempSnapshotArray.splice(delIndex, 1);

    setSnapshotArray(tempSnapshotArray);
  };

  const handleRename = (event) => {
    console.log("rename");
  };
  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenDialog(false);
  };

  function handleClick(saveType) {
    const foundIndex = snapshotArray.findIndex(
      (elem) => elem.name == whiteboardName,
    );
    if (foundIndex >= 0) {
      alert("name exists");
    }

    const snapshot = editor.current.store.getSnapshot();
    const stringifiedSnapshot = JSON.stringify(snapshot);
    localStorage.setItem("my-editor-snapshot", stringifiedSnapshot);
    setOpenSaving(true);
    editor.current.getSvg(editor.current.getCurrentPageShapes()).then((svg) => {
      var svgData = new XMLSerializer().serializeToString(svg);

      var canvas = document.createElement("canvas");
      canvas.width = 1500;
      canvas.height = 1000;
      var ctx = canvas.getContext("2d");

      var img = document.createElement("img");
      img.setAttribute("src", "data:image/svg+xml;base64," + btoa(svgData));

      img.onload = () => {
        ctx.drawImage(img, 0, 0);

        // Now is done
        console.log(canvas.toDataURL("image/png"));

        const dataURL64 = canvas
          .toDataURL("image/png")
          .replace(/^data:image\/?[A-z]*;base64,/, "");

        //const description = whiteboardName + ".png";
        const description =
          saveType == "attachment" ? whiteboardName + ".png" : whiteboardName;

        if (saveType == "attachment") {
          if (!workspaceid.current) {
            const tempWsId = sessionStorage.getItem("tempWorkspaceId");
            if (tempWsId) {
              workspaceid.current = tempWsId;
              localStorage.removeItem("tempWorkspaceId");
            } else {
              setOpenDialog(true);
            }
          }

          if (workspaceid.current) {
            const requestString =
              authString +
              '<Add type="Attachment"><Attachment><name>' +
              description +
              "</name><file_name>" +
              description +
              //newAttachment.current.description +
              "</file_name><workspaceid>" +
              workspaceid.current +
              "</workspaceid><base64_data>" +
              dataURL64 +
              "</base64_data><notes>Added through Addolution CollabCenter</notes></Attachment></Add></request>";

            Tools.fetchPost(requestString, urlString, "Attachment").then(
              (newRec) => {
                setOpenSaving(false);
                setOpenConfirmation(true);
                const newRecArray = Tools.xmlToArray(newRec.xml);
                const newId = newRecArray[0].id;

                // this shouldn't be necessary, but OA....
                const modifyRequestString =
                  authString +
                  '<Modify type="Attachment"><Attachment><id>' +
                  newId +
                  "</id><name>" +
                  description +
                  "</name></Attachment></Modify></request>";
                Tools.fetchPost(modifyRequestString, urlString);
              },
            );
          }
        } else if (saveType == "snapshot") {
          const snapshotRequestString =
            authString +
            '<Add type="Preference"><Preference><group_name>tldrawSnapshots_proj' +
            props.projectObject.id +
            "</group_name><userid>0</userid><name>" +
            description +
            "</name><setting>" +
            stringifiedSnapshot +
            "</setting></Preference></Add></request>";
          Tools.fetchPost(snapshotRequestString, urlString).then(() => {
            populateSnapshots();
          });
        }
      };
      //}
    });
  }

  function populateSnapshots() {
    const snapshotRequestString =
      authString +
      '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>tldrawSnapshots_proj' +
      props.projectObject.id +
      "</group_name></Preference></Read></request>";
    Tools.fetchPost(snapshotRequestString, urlString, "Preference").then(
      (prefs) => {
        if (prefs.xml.length > 0) {
          const prefArray = Tools.xmlToArray(prefs.xml);
          const newSnapshotArray = [];
          prefArray.forEach((elem) =>
            newSnapshotArray.push({
              name: elem.name,
              snapshot: elem.setting,
              id: elem.id,
              lastSaved: elem.updated,
            }),
          );
          setSnapshotArray(newSnapshotArray);
        }
      },
    );
  }

  const loadSnapshot = (event) => {
    //event.target.dataset.snapshot
    console.log("Filename: " + event.target.dataset.filename);
    editor.current.store.loadSnapshot(
      JSON.parse(event.target.dataset.snapshot),
    );
    setWhiteboardName(event.target.dataset.filename);
  };

  function CustomQuickActions() {
    return (
      <DefaultQuickActions>
        <DefaultQuickActionsContent />
        <TldrawUiMenuItem
          id="save_snapshot"
          icon="save"
          onSelect={() => handleClick("snapshot")}
        />
        <TldrawUiMenuItem
          id="save_file"
          icon="page"
          onSelect={() => handleClick("attachment")}
        />
      </DefaultQuickActions>
    );
  }

  const components = {
    QuickActions: CustomQuickActions, // null will hide the page menu instead
  };

  function formatLastUpdated(dateStr) {
    const hour = dateStr.substring(0, 2);
    const minute = dateStr.substring(2, 4);
    //const second = dateStr.substring(4, 6);
    const month = dateStr.substring(6, 8);
    const day = dateStr.substring(8, 10);
    const year = dateStr.substring(10);

    return year + "-" + month + "-" + day + "  " + hour + ":" + minute + " EST";
  }
  return (
    <>
      <CustomAlert
        alertText="Whiteboard Saved to Workspace"
        openAlert={openConfirmation}
        setOpenAlert={setOpenConfirmation}
      />
      <CustomAlert
        alertText="Saving..."
        openAlert={openSaving}
        setOpenAlert={setOpenSaving}
        backgroundColor="#643f69"
      />
      <Box sx={{ backgroundColor: "white", flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Box sx={{ padding: "30px" }}>
              <Box
                sx={{
                  backgroundColor: "white",
                  width: "300px",
                }}
              >
                <TextField
                  variant="standard"
                  onChange={handleNameChange}
                  value={whiteboardName}
                  label="Enter Whiteboard Name"
                  sx={{ margin: "0px 10px", width: "280px" }}
                ></TextField>
              </Box>
              <Box
                sx={{
                  width: "325px",
                  backgroundColor: "white",
                  padding: "5px",
                  margin: "150px 5px 10px 0px",
                  border: "none",
                  borderRadius: "15px",
                }}
              >
                <Typography variant="h6" sx={{ color: "#154360" }}>
                  SAVED SNAPSHOTS
                </Typography>
                <hr></hr>
                {snapshotArray.map((elem, index) => (
                  <div key={"snapshot" + index} style={{ paddingTop: "15px" }}>
                    <img
                      id={"delete_" + elem.id}
                      height={20}
                      width={20}
                      src="/delete-svgrepo-com.svg"
                      onClick={handleDelete}
                      style={{ cursor: "normal" }}
                    ></img>
                    <img
                      id={"rename_" + elem.id}
                      height={20}
                      width={20}
                      src="/edit-2-svgrepo-com.svg"
                      onClick={handleRename}
                      style={{ cursor: "normal" }}
                    ></img>
                    <Tooltip title={formatLastUpdated(elem.lastSaved)}>
                      <span
                        id={elem.id}
                        data-snapshot={elem.snapshot}
                        data-filename={elem.name}
                        onClick={loadSnapshot}
                        style={{
                          color: "#154360",
                          textDecoration: "underline",
                          paddingLeft: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {elem.name}
                      </span>
                    </Tooltip>
                  </div>
                ))}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box>
              <div
                id="capture"
                style={{ position: "fixed", inset: 50, left: 400 }}
              >
                <Tldraw
                  persistenceKey={sessionStorage.getItem("persistenceKey")}
                  components={components}
                  onMount={handleMount}
                  assetUrls={{
                    icons: {
                      save: "/save-technology-svgrepo-com.svg",
                    },
                  }}
                />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Dialog open={openDialog} onClose={handleClose} maxWidth="400px">
        <Dialog_AddWorkspace
          handleClose={handleClose}
          handleAlertClose={handleAlertClose}
          waitHandler={props.waitHandler}
          creds={creds}
          projectObject={props.projectObject}
          setOpenDialog={setOpenDialog}
          setOpenConfirmation={setOpenWsConfirmation}
        />
      </Dialog>
    </>
  );
}

export default TLDrawComponent;
TLDrawComponent.propTypes = {
  projectObject: PropTypes.object,
  waitHandler: PropTypes.func,
};

/*
<div id="capture" style={{ position: "fixed", inset: 50 }}>


        <Tldraw onUiEvent={handleEvent} onMount={handleMount} />




      <div id="capture" style={{ padding: "10px", backgroundColor: "#f5da55" }}>
        <h4 style={{ color: "#000" }}>Hello world!</h4>
      </div>

*/

/*const handleCapture = (event) => {
    html2canvas(document.querySelector("#capture")).then((canvas) => {
      //document.body.appendChild(canvas);

      const croppedCanvas = document.createElement("canvas");
      const croppedCanvasContext = croppedCanvas.getContext("2d");

      const cropPositionLeft = 0;
      const cropPositionTop = 0;
      const cropWidth = 1500;
      const cropHeight = 1300;

      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeight;

      croppedCanvasContext.drawImage(
        canvas,
        cropPositionLeft,
        cropPositionTop,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight,
      );

      const dataURL = croppedCanvas.toDataURL("image/png");
      const dataURL64 = dataURL.replace(/^data:image\/?[A-z]*;base64,/, "");

      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const timestamp = new Date().getTime();
      const description = "foo to the bar " + timestamp + ".png";
      const workspaceid = 13;

      const requestString =
        authString +
        '<Add type="Attachment"><Attachment><name>' +
        description +
        "</name><file_name>" +
        description +
        //newAttachment.current.description +
        "</file_name><workspaceid>" +
        workspaceid +
        "</workspaceid><base64_data>" +
        dataURL64 +
        "</base64_data></Attachment></Add></request>";

      Tools.fetchPost(requestString, urlString, "Attachment").then((newRec) => {
        const newRecArray = Tools.xmlToArray(newRec.xml);
        const newId = newRecArray[0].id;

        // this shouldn't be necessary, but OA....
        const modifyRequestString =
          authString +
          '<Modify type="Attachment"><Attachment><id>' +
          newId +
          "</id><name>" +
          description +
          "</name></Attachment></Modify></request>";
        Tools.fetchPost(modifyRequestString, urlString);
      });
    });
  };
*/

/*if (img.complete) {
        ctx.drawImage(img, 0, 0);

        // Now is done
        //console.log(canvas.toDataURL("image/png"));

        const dataURL64 = canvas
          .toDataURL("image/png")
          .replace(/^data:image\/?[A-z]*;base64,/, "");

        const description = whiteboardName + ".png";

        if (saveType == "attachment") {
          if (!workspaceid.current) {
            const tempWsId = sessionStorage.getItem("tempWorkspaceId");
            if (tempWsId) {
              workspaceid.current = tempWsId;
              localStorage.removeItem("tempWorkspaceId");
            } else {
              setOpenDialog(true);
            }
          }

          if (workspaceid.current) {
            const requestString =
              authString +
              '<Add type="Attachment"><Attachment><name>' +
              description +
              "</name><file_name>" +
              description +
              //newAttachment.current.description +
              "</file_name><workspaceid>" +
              workspaceid.current +
              "</workspaceid><base64_data>" +
              dataURL64 +
              "</base64_data></Attachment></Add></request>";

            Tools.fetchPost(requestString, urlString, "Attachment").then(
              (newRec) => {
                setOpenSaving(false);
                setOpenConfirmation(true);
                const newRecArray = Tools.xmlToArray(newRec.xml);
                const newId = newRecArray[0].id;

                // this shouldn't be necessary, but OA....
                const modifyRequestString =
                  authString +
                  '<Modify type="Attachment"><Attachment><id>' +
                  newId +
                  "</id><name>" +
                  description +
                  "</name></Attachment></Modify></request>";
                Tools.fetchPost(modifyRequestString, urlString);
              },
            );
          }
        } else if (saveType == "snapshot") {
          const snapshotRequestString =
            authString +
            '<Add type="Preference"><Preference><group_name>tldrawSnapshots_proj' +
            props.projectObject.id +
            "</group_name><userid>0</userid><name>" +
            description +
            "</name><setting>" +
            stringifiedSnapshot +
            "</setting></Preference></Add></request>";
          Tools.fetchPost(snapshotRequestString, urlString).then(() => {
            populateSnapshots();
          });
        }
      } else {*/
